import React, { useEffect, useState } from "react";
import { Sidebar } from "./components/Sidebar";
import { Payments } from "./components/Payments";
import "./output.css";
import { Subscriptions } from "./components/Subscriptions";
import { Whitelist } from "./components/Whitelist";
import { Images } from "./components/Images";
import { Config } from "./components/Config";

// const BASE = "http://localhost:9999";
// const BASE = "https://webhook.harmonyalgo.com/api";
const menuItems = [
  { id: "payments", label: "Payments" },
  { id: "subscriptions", label: "Subscriptions" },
  { id: "whitelist", label: "Whitelist" },
  { id: "images", label: "Images" },
  { id: "config", label: "Config" },
];

const App = () => {
  const [activeTab, setActiveTab] = useState('payments');

  useEffect(() => {
    setActiveTab(localStorage.getItem('last_tab'))
  }, [])
  // setActiveTab(localStorage.getItem('last_tab'))

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="flex h-screen bg-zinc-950">
      <Sidebar
        menuItems={menuItems}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {/* Main content */}
      <main className="flex-1 p-8 overflow-auto">
        {activeTab === "payments" && <Payments formatDate={formatDate} />}
        {activeTab === "subscriptions" && (
          <Subscriptions formatDate={formatDate} />
        )}
        {activeTab === "whitelist" && <Whitelist formatDate={formatDate} />}
        {activeTab === "images" && <Images formatDate={formatDate} />}
        {activeTab === "config" && <Config formatDate={formatDate} />}
      </main>
    </div>
  );
};

export default App;
